<template>
  <div class="url-dropper"
    v-if="url || !disabled"
  >
    <!--
      TODO: Also prompt for password for `alt_file_credentials`
            Note: Make sure connection is HTTPS.
    -->
    <el-popover
      class="url-dropper__popover"
      ref="urldropperpopover"
      placement="bottom-start"
      title="Submit with URL"
      :width="280"
      :offset="-10"
      :appendToBody="false"
      :value="popoverActive"
      trigger="manual"
    >
      <div v-if="!disabled">
        <p>
          You can share your private links from WeTransfer, Dropbox,
          Google Drive, Vimeo or YouTube here e.g. <code>https://vimeo.com/12345678</code>
        </p>
        <p>
          and add your password too, if any
        </p>
      </div>
      <p v-else>
        Password shared for this link submission
      </p>

      <div style="margin-top: -12px;">
        <el-input
          class="url-dropper__passphrase"
          :class="showPassphrase ? 'hint' : ''"
          v-model="form.password"
          @input="updateForm"
          @focus="triggerPopover(true)"
          @blur="triggerPopover(false)"
          :disabled="disabled"
        >
          <el-button
            type="text"
            :icon="'el-icon-view'"
            slot="suffix"
            class="url-dropper__passphrase__hint el-input__icon"
            @click="triggerHint"
          />
        </el-input>
      </div>
      <div class="url-dropper__popover__close-btn">
        <el-button
          @click="triggerPopover(false)"
          icon="el-icon-close"
          type="text"
        ></el-button>
      </div>
    </el-popover>

    <el-form
      :model="form"
      :rules="rules"
    >
      <el-form-item prop="url">
        <el-input
          v-model="form.url"
          v-popover:urldropperpopover
          @input="updateForm"
          @focus="triggerPopover(true)"
          @blur="triggerPopover(false)"
          placeholder="Or, film already uploaded? Paste the URL here"
          :disabled="disabled"
        >
        </el-input>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  props: {
    url: {},
    password: {},
    value: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rules: {
        url: [
          { max: 215, message: 'Length should not exceed 215 characters', trigger: 'change' },
        ],
      },
      showPassphrase: false,
      popoverActive: false,
    };
  },
  computed: {
    form() {
      return {
        url: this.value.video_file_url_alt,
        password: this.value.alt_file_credentials,
      };
    },
  },
  methods: {
    updateForm: debounce(function updatePassword(value) {
      this.$emit('input', {
        url: this.form.url,
        password: this.form.password,
      });
    }, 200),
    triggerPopover(active) {
      this.popoverActive = active;
    },
    triggerHint() {
      this.popoverActive = true;
      this.showPassphrase = !this.showPassphrase;
    },
  },
  mounted() {
    const shouldShowPopoverOnStart = (this.url) && // contains URL
                                     !(this.disabled && !this.password); // is not disabled and doesn't contain password

    // automatically expand the password field if url is filled
    if (shouldShowPopoverOnStart) {
      this.popoverActive = true;
    }
  },
};
</script>

<style lang="scss">
@import '~text-security/dist/text-security.css';

.url-dropper {
  width: 100%;

  input {
    width: 100%;
    padding: 4px 8px;
  }
}
.url-dropper__button {
  width: 95px;
  text-transform: capitalize;
}

.url-dropper__popover__close-btn {
  position: absolute;
  right: 8px;
  top: 0px;
}

// Use a cross browser text hiding implementation
// by changing the font face of the text instead
.url-dropper__passphrase {
  input {
    font-family: "text-security-disc";
    letter-spacing: 2px;
  }
  &.hint input {
    font-family: inherit;
    letter-spacing: inherit;
  }

  // Implement an eye toggler
  i {
    position: relative;
  }
  i::after{
    content: '';
    border: 0.5px solid $--color-primary;
    height: 0;
    width: 15px;
    left: -2px;
    top: 0;
    position: absolute;
    right: 0;
    margin: auto;
    bottom: 0;
    transform: rotate(-45deg);
    opacity: 0;

    transition: opacity $transition-s-s;
  }
  &.hint i::after {
    opacity: 0.6;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Submission/steps/VideoUpload/UrlDropper.vue